import React from "react"
import PropTypes from "prop-types"

import css from "./ChildItem.scss"
import { isPwaUrl } from "@lib/urlMatchUtility"
import GaEvents from "@containers/Header/GaEvents"
import ConditionalLink from "@wrappers/ConditionalLink/ConditionalLink"

const { array } = PropTypes

const ChildItem = ({ segmentChild }) => (
    <ul className={css.childList}>
        {segmentChild.map((child, l) => {
            return (
                <li itemProp="name" key={l}>
                    {child.slug ? (
                        <ConditionalLink
                            to={child.slug}
                            className={
                                child.level === 2
                                    ? `${css.level2} smallSemiBold textPrimary marginTop-16`
                                    : `${css.level3} smallRegular marginTop-8`
                            }
                            isExternal={!isPwaUrl(child.slug)}
                            onClick={() => GaEvents.onUdpDesktopClick(`${child.name}, ${location.href}`)}
                        >
                            <span className={css.linkText}>{child.name}</span>
                        </ConditionalLink>
                    ) : (
                        <span
                            className={child.level === 2 ? css.level2 : css.level3}
                            onClick={() => GaEvents.onUdpDesktopClick(`${child.name}, ${location.href}`)}
                        >
                            <span className={css.linkText}>{child.name}</span>
                        </span>
                    )}
                </li>
            )
        })}
    </ul>
)

ChildItem.propTypes = {
    segmentChild: array,
}

export default ChildItem
